import { StyleSheet } from '@react-pdf/renderer';

export const invoiceHeaderStyle = StyleSheet.create({
    wrapper: {
        paddingBottom: 20,
    },
    topRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 20,
    },
    invoiceSection: {
        alignItems: 'flex-start',
    },
    invoiceLabel: {
        fontSize: 32,
        fontWeight: 'bold',
        color: '#000',
    },
    invoiceNumber: {
        fontSize: 14,
        color: '#676F80',
    },
    logo: {
        maxWidth: 250,
        maxHeight: 60,
        objectFit: 'contain',
        alignSelf: 'flex-end',
        marginBottom: 20,
    },
    logoPlaceholder: {
        fontSize: 12,
        color: '#666',
        textAlign: 'center',
    },
    sectionsRow: {
        flexDirection: 'row',
        borderTopWidth: 1,
        borderTopColor: '#E4EBFB',
        borderTopStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: '#E4EBFB',
        borderBottomStyle: 'solid',
    },
    section: {
        flex: 1,
        padding: 16,
        borderRightWidth: 1,
        borderRightColor: '#E4EBFB',
        borderRightStyle: 'solid',
        gap: 4,
    },
    sectionLast: {
        flex: 1,
        padding: 16,
        gap: 4,
    },
    dateItem: {
        gap: 4,
    },
    label: {
        fontSize: 10,
        color: '#000',
    },
    value: {
        fontSize: 12,
        color: '#676F80',
    },
    title: {
        fontSize: 12,
        color: '#000',
    },
    address: {
        fontSize: 10,
        lineHeight: 1.5,
        color: '#676F80',
    },
});
